import { FC, useMemo } from 'react';
import CoolImg from 'react-cool-img';
import { ICONS } from 'shared/constants/images';

interface ImageProps {
  src: string;
  style?: React.CSSProperties;
  className?: string;
  error?: string;
  onClick?: CallableFunction;
}

export const Image: FC<ImageProps> = (props: ImageProps) => {
  const { src, style, className, error, onClick } = props;

  return useMemo(
    () => (
      <CoolImg
        onClick={onClick}
        src={src}
        style={style}
        className={className}
        error={error}
        alt='Image'
        lazy
        cache
        placeholder={ICONS.loadingSpinner}
      />
    ),
    [onClick, src, style, className, error]
  );
};
